import { render, staticRenderFns } from "./groupTeam.vue?vue&type=template&id=24b7883c&scoped=true&"
import script from "./groupTeam.vue?vue&type=script&lang=js&"
export * from "./groupTeam.vue?vue&type=script&lang=js&"
import style0 from "./groupTeam.vue?vue&type=style&index=0&id=24b7883c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7883c",
  null
  
)

export default component.exports